import React, {Component} from 'react';
import { push } from "connected-react-router";
import connect from "react-redux/es/connect/connect";
import { userRegistration, checkExistingLogin } from '../../actions/authActions';
import { closeAlert } from '../../actions/commonsActions';
import validators from '../../helpers/validators';
import {
	Input,
	CustomInput,
	FormGroup,
	Form,
	Row,
	Col,
	Button,
	Alert
} from 'reactstrap';

import img1 from '../../assets/images/ap/ap-small.jpg';
import img2 from '../../assets/images/background/login-register.jpg';

const sidebarBackground = {
	backgroundImage: `url(${img2})`,
	backgroundRepeat: 'no-repeat',
	backgroundPosition: 'bottom center'
};

const alerStyle = {
	position: 'relative',
  top: '0',
  right: '0'
}

class Register extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: '',
			password: '',
			error: null
		};
		this.validators = validators;
	};

	signIn = event => {
		event.preventDefault();
		this.props.closeAlert();
		this.props.changeLocation('/login');
	};

	signUp = event => {
		event.preventDefault();
		const loginForm = document.getElementById('loginform');
		if (this.isFormValid()) {
			this.props.checkExistingLogin(this.state.email)
				.then(() => {
					return this.props.userRegistration({
						username: this.state.email,
						password: this.state.password
					})
				}, error => {
					throw new Error(error);
				})
				.then((result) => {
					this.setState({
						login: '',
						password: ''
					})
					if (result.login) {
						setTimeout(() => {
							this.props.closeAlert();
							this.props.changeLocation('/login');
						}, 4000);
					}
				}).catch((err) => {
				console.log(err)
			})
		}
	};

	onInputChange = event => {
		this.setState({
			[event.target.name]: event.target.value
		});
		this.formValidators([event.target.name], event.target.value);
	};

	formValidators = (fieldName, value) => {
		this.validators[fieldName].errors = [];
		this.validators[fieldName].state = value;
		this.validators[fieldName].valid = true;
		this.validators[fieldName].rules.forEach(rule => {
			if (rule.test instanceof RegExp) {
				if (!rule.test.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			} else if (typeof rule.test === 'function') {
				if (!rule.test(value)) {
					this.validators[fieldName].errors.push(rule.message);
					this.validators[fieldName].valid = false;
				}
			}
		});
	};

	isFormValid = () => {
		let status = true;
		Object.keys(this.validators).forEach(field => {
			if (!this.validators[field].valid) {
				status = false;
			}
		});
		return status;
	};

	showErrors = fieldName => {
		const validator = this.validators[fieldName];
		const result = '';
		if (validator && !validator.valid) {
			const errors = validator.errors.map((info, index) => {
				return (
					<span className="error" key={index}>
           			 	* {info}
						<br/>
          			</span>
				);
			});

			return <div className="error mb-2">{errors}</div>;
		}
		return result;
	};

	render() {
		return <div className="">
			{/*--------------------------------------------------------------------------------*/}
			{/*Register Cards*/}
			{/*--------------------------------------------------------------------------------*/}
			<div className="auth-wrapper d-flex no-block justify-content-center align-items-center" style={sidebarBackground}>
				<div className="auth-box on-sidebar">
					<div id="mainform">
						<div className="logo">
							<span className="db"><img src={img1} alt="logo"/></span>
							<h5 className="font-medium mb-3">Sign Up to Admin</h5>
						</div>
						<Row>
							<Col xs="12">
								<Form
									className="mt-3"
									id="loginform"
									action="/"
									onSubmit={this.signUp}
								>
									<FormGroup className="mb-3">
										<Input
											type="email"
											name="email"
											id="email"
											placeholder="Email"
											bsSize="lg"
											value={this.state.email}
											onChange={this.onInputChange}
											onFocus={this.props.closeAlert}
											required
										/>
									</FormGroup>
									{this.showErrors('email')}
									<FormGroup className="mb-3">
										<Input
											type="password"
											name="password"
											id="password"
											placeholder="Password"
											bsSize="lg"
											value={this.state.password}
											onChange={this.onInputChange}
											onFocus={this.props.closeAlert}
											required
										/>
									</FormGroup>
									{this.showErrors('password')}
									<CustomInput type="checkbox" id="exampleCustomCheckbox" label="I agree to all Terms"/>
									<Row className="mb-3 mt-3">
										<Col xs="12">
											<Button
												color="primary"
												size="lg"
												className={`text-uppercase ${
													this.isFormValid() ? '' : 'disabled'
													}`}
												type="submit"
												block

											>
												Sign Up
											</Button>
										</Col>
									</Row>
									<div className="text-center">
										Already have an account? <a href="/authentication/login" className="text-info ml-1"
																	onClick={this.signIn}><b>Sign In</b></a>
									</div>
								</Form>
							</Col>
						</Row>
					</div>
					{/*----------------------- alerts -----------------------------------*/}
					<Alert
						style={alerStyle}
						color={`${this.props.alert.alert.status}`}
						isOpen={this.props.alert.isOpen || false}
					>
						{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
					</Alert>
				</div>
			</div>
		</div>;
	}
}

const mapDispatchToProps = dispatch => {
	return {
		changeLocation: (url) => dispatch(push(url)),
		userRegistration: (credentials) => dispatch(userRegistration(credentials)),
		checkExistingLogin: (email) => dispatch(checkExistingLogin(email)),
		closeAlert: () => dispatch(closeAlert())
	};
};

const mapStateToProps = state => ({
	alert: state.alert
});

export default connect(mapStateToProps, mapDispatchToProps)(Register)



// WEBPACK FOOTER //
// ./src/views/authentication/register.jsx